import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import API from '../../../util/api';

const LINK_HOVER_COLOR = "#F7941D";

const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: ${(props) => props.colors.formBackground};
  margin-top: 10px;
  width: 100%;
  height: 100%;
`;

const Notification = styled.div`
  font-size: 1rem;
  color: #000;
  padding: 20px 20px;
  border-bottom: 1px solid #ccc;

  &:last-child {
    border-bottom: none;
  }

  a {
    color: ${(props) => props.colors.buttonBackground};
    text-decoration: none;
    font-weight: bold;

    &:hover {
      color: ${LINK_HOVER_COLOR};
      text-decoration: underline;
    }
  }

  .LinkButton {
    margin-left: 10px;
    color: ${(props) => props.colors.buttonBackground};
    // color: ${(props) => props.colors.buttonText};
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 3px;
    text-decoration: none;
    font-weight: bold;

    &:hover {
      color: ${LINK_HOVER_COLOR};
    }
  }
`;

export default function AdminNotificationPanel({ colors }) {
  const navigate = useNavigate();

  // POC changes state
  const [pocChanges, setPocChanges] = useState([]);
  const [pocLoading, setPocLoading] = useState(false);

  // Email stats state
  const [emailStats, setEmailStats] = useState({ sent: 0, failed: 0, period: 10 });
  const [emailLoading, setEmailLoading] = useState(false);

  // Load POC updates
  useEffect(() => {
    const loadPOCs = async () => {
      setPocLoading(true);
      try {
        const resp = await API.getPOCChanges({});
        if (resp.status === 'Success' && Array.isArray(resp.poc_changes)) {
          setPocChanges(resp.poc_changes);
        } else {
          setPocChanges([]);
        }
      } catch (err) {
        console.error('Failed to load POCs:', err);
        setPocChanges([]);
      } finally {
        setPocLoading(false);
      }
    };
    loadPOCs();
  }, []);

  // Load Email stats (last 10 days)
  useEffect(() => {
    const loadEmailStats = async () => {
      setEmailLoading(true);
      try {
        const resp = await API.getEmailLog({"page": 0,
    "items_per_page": 10
});
        if (resp.status === 'Success' && resp.last_10_days) {
          setEmailStats({
            sent: resp.last_10_days.sent_count ?? 0,
            failed: resp.last_10_days.failed_count ?? 0,
            period: resp.last_10_days.period_days ?? 10, // if provided
          });
        }
      } catch (err) {
        console.error('Failed to load email stats:', err);
      } finally {
        setEmailLoading(false);
      }
    };
    loadEmailStats();
  }, []);

  // Computed values
  const pocUpdateCount = pocChanges.length;
  const pocLastUpdate =
    pocChanges.length > 0
      ? pocChanges
          .map((c) => new Date(c.change_poc_date))
          .reduce(
            (min, d) => (d < min ? d : min),
            new Date(pocChanges[0].change_poc_date)
          )
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')
      : '—';

  return (
    <ViewContainer colors={colors}>
      <Notification colors={colors}>
        <a
          onClick={() =>
            navigate('/admincentral/subscriptions/search', {
              state: { defaultTab: 'POC Updates' },
            })
          }
          style={{textDecoration: 'underline'}}
        >
          <strong>{pocLoading ? '…' : pocUpdateCount}</strong> POC updates since{' '}
          <strong>{pocLoading ? 'loading…' : pocLastUpdate}</strong> need to be
          confirmed by the accountant.
        </a>
      </Notification>

      <Notification colors={colors}>
        <strong>{emailLoading ? '…' : emailStats.sent}</strong> emails sent
        in past {emailStats.period} days.
      </Notification>

      <Notification colors={colors}>
        <strong>{emailLoading ? '…' : emailStats.failed}</strong> emails failed
        in past {emailStats.period} days{' '}
        <a className="LinkButton" onClick={() => {/* reset logic here */}}>
          Reset
        </a>
      </Notification>
    </ViewContainer>
  );
}
